import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions, ResponseContentType} from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';
import { AppConfig } from 'app/app.config';
import { Evaluacion } from 'app/models/evaluaciones/evaluacion';
import { FormGroup } from '@angular/forms';
import { environment } from 'environments/environment';


@Injectable()
export class EvaluacionService {

  public token: string;
  private headers: Headers = new Headers({'Content-Type': 'application/json'});
  constructor(private http: Http, private config: AppConfig) {  }


  put(idconvocatoria, idcentro, idtipoevaluacion, idevaluador, accion, fecha_comision) {
    const parametros = idconvocatoria + '/' + idcentro + '/' + idtipoevaluacion + '/' + idevaluador;
    console.log(environment.apiUrl + '/evaluaciones/' + parametros);
        // tslint:disable-next-line:max-line-length
    return this.http.put(environment.apiUrl + '/evaluaciones/' + parametros, JSON.stringify({operacion: accion,fecha_comision: fecha_comision}), this.jwt()).map((response: Response) => response.json());
  }


  post(idconvocatoria, idcentro, idtipoevaluacion, idevaluador) {
    const parametros = idconvocatoria + '/' + idcentro + '/' + idtipoevaluacion + '/' + idevaluador;
    console.log(environment.apiUrl + '/evaluaciones/' + parametros);
        // tslint:disable-next-line:max-line-length
    return this.http.post(environment.apiUrl + '/evaluaciones/' + parametros,'',this.jwt()).map((response: Response) => response.json());
  }

  delete(idconvocatoria, idcentro, idtipoevaluacion, idevaluador) {
    const parametros = idconvocatoria + '/' + idcentro + '/' + idtipoevaluacion + '/' + idevaluador;
    console.log(environment.apiUrl + '/evaluaciones/' + parametros);
        // tslint:disable-next-line:max-line-length
    return this.http.put(environment.apiUrl + '/evaluaciones/desasignar/' + parametros,'',this.jwt()).map((response: Response) => response.json());
  }


  putForm(idconvocatoria, idcentro, idtipoevaluacion, idevaluador, accion, EForm: FormGroup) {
    const parametros = idconvocatoria + '/' + idcentro + '/' + idtipoevaluacion + '/' + idevaluador;
    console.log(environment.apiUrl + '/evaluaciones/' + parametros);
    console.log(JSON.stringify({operacion: 4, evaluacion: EForm}));
        // tslint:disable-next-line:max-line-length
    return this.http.put(environment.apiUrl + '/evaluaciones/' + parametros, JSON.stringify({operacion: accion, evaluacion: EForm}), this.jwt()).map((response: Response) => response.json());
  }



  get(idconvocatoria, idcentro, idtipoevaluacion, idevaluador) {
    const parametros = idconvocatoria + '/' + idcentro + '/' + idtipoevaluacion + '/' + idevaluador;
    console.log(environment.apiUrl + '/evaluaciones/' + parametros);
        // tslint:disable-next-line:max-line-length
    return this.http.get(environment.apiUrl + '/evaluaciones/' + parametros, this.jwt()).map((response: Response) => response.json());
  }



  getDOCEVALUACION(idconvocatoria, idcentro, idtipoevaluacion, idevaluador, vistaprevia: boolean) {
    const parametros = idconvocatoria + '/' + idcentro + '/' + idtipoevaluacion + '/' + idevaluador;
    console.log(this.jwtBlob());
        // tslint:disable-next-line:max-line-length
    let action = '';
    if (!vistaprevia) { action = '/evaluacion/' } else { action = '/evaluacion/vistaprevia/' }
    console.log(environment.apiUrl + action + parametros);
    return this.http.get(environment.apiUrl + action + parametros, this.jwtBlob()).map((response: Response) => response.text());

  }

  getDOCEVALUACION_SEG(idconvocatoria, idcentro, idtipoevaluacion, idevaluador) {
    const parametros = idconvocatoria + '/' + idcentro + '/' + idtipoevaluacion + '/' + idevaluador;
    console.log(this.jwtBlob());
        // tslint:disable-next-line:max-line-length
    let action = '';
    action = '/evaluacion/seguimiento/';
    console.log(environment.apiUrl + action + parametros);
    return this.http.get(environment.apiUrl + action + parametros, this.jwtBlob()).map((response: Response) => response.text());

  }



  private jwt() {
    // create authorization header with jwt token
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log(currentUser.token);
    if (currentUser && currentUser.token) {
        const headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token , 'Content-Type': 'application/json' });
        return new RequestOptions({ headers: headers });
    }
  }

  private jwtBlob() {
    // create authorization header with jwt token
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.token) {
        let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
        // headers = new Headers({ResponseContentType : Text});
        return new RequestOptions({ headers: headers });
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/evaluacion.service.ts